import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';
import PremiumFeatureBanner from '@core/components/premiumfeaturebanner/PremiumFeatureBanner';

import { useSelector } from 'react-redux';

import Note from 'assets/icons/note-empty-2.svg';

import classes from './CoverLetterEmptyState.module.scss';

const CoverLetterEmptyState = () => {
    const hasSubscription = useSelector(state => state.user.hasSubscription);
    return (
        <div className={classes["wrapper"]}>
            <Note />
			<h3>You haven’t created your cover letter yet.</h3>
            {false ? (
                <div className={classes['line']}>  
					<PremiumFeatureBanner />
                </div>
            ) : (
                <>     
                <p>Try your first cover letter and prepare yourself for the right job.</p>           
                    <LinkButton
                        className={`${classes['create-cover-letter']}`}
                        to='/cover-letter/new'
                        kind='primary-color'>
                        Start my first cover letter
                    </LinkButton>
                </>
            )}
        </div>
    );
};

export default CoverLetterEmptyState;